var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZvukColorDarkPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zvuk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zvuk-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_ru"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 72,
    cy: 26,
    r: 20,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M75.5754 26.8972C73.936 26.8972 72.6023 28.3203 72.6023 30.0698C72.6023 30.0812 72.6026 30.0925 72.6031 30.1002C72.5958 30.3656 72.6306 31.2111 73.2462 32.3762C74.0529 33.9028 75.503 35.3351 77.5568 36.634C77.5968 36.6639 77.6422 36.6874 77.6915 36.7029C77.7358 36.7168 77.7812 36.7237 77.8265 36.7237C77.8743 36.7237 77.922 36.716 77.9671 36.7011C78.0206 36.682 78.0561 36.6634 78.0883 36.6407C80.1422 35.3418 81.5923 33.9095 82.399 32.3828C83.0145 31.2178 83.0494 30.3723 83.042 30.1067C83.0424 30.0992 83.0429 30.0878 83.0429 30.0765C83.0429 28.327 81.709 26.9039 80.0696 26.9039C79.1884 26.9039 78.0883 27.4063 77.8259 28.5483C77.5568 27.3996 76.4568 26.8972 75.5754 26.8972Z",
    fill: "url(#paint0_linear_108_363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M73.5938 14.0611C73.4536 13.981 73.2798 13.9795 73.1383 14.0575C72.9968 14.1355 72.9094 14.2809 72.9094 14.4386V24.309C72.9094 24.4664 72.9968 24.612 73.1383 24.69C73.2079 24.7284 73.2853 24.7477 73.3627 24.7477C73.4427 24.7477 73.5226 24.7271 73.5938 24.6864L82.2065 19.7513C82.3443 19.6722 82.4288 19.5287 82.4288 19.3737C82.4288 19.2188 82.3443 19.0752 82.2065 18.9962L73.5938 14.0611Z",
    fill: "url(#paint1_linear_108_363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M69.5316 14.8652C69.5316 14.6585 69.417 14.4686 69.2335 14.3712C68.7375 14.1079 67.9719 14.6944 67.9719 15.4256V29.8409C65.0103 28.4213 61.5476 30.6009 61.5476 33.5478C61.5476 35.1069 62.5825 36.4166 64.9369 36.4166C67.2642 36.4166 69.5184 34.3239 69.5316 30.7376V14.8652Z",
    fill: "url(#paint2_linear_108_363)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M136.705 22.2991H140.145L139.43 25.8067H140.463L142.949 22.2991H146.887L142.929 27.4541V27.4926L145.296 32.2796H141.577L139.946 28.6169H138.873L138.137 32.2796H134.697L136.705 22.2991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M124.357 33.5589C124.954 33.5589 125.67 33.4039 126.207 32.551L126.505 32.0856L124.099 22.2991H127.678L128.514 27.241C128.613 27.7835 128.613 28.7139 128.613 28.7139H128.653C128.653 28.7139 129.011 27.842 129.269 27.2991L131.556 22.2991H135.414L129.011 33.3455C127.738 35.5357 125.968 36.3496 124.536 36.3496C123.622 36.3496 122.647 36.0782 121.852 35.5742L123.343 33.2489C123.602 33.4424 124.019 33.5589 124.357 33.5589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.765 22.2991H114.276L112.268 32.2796H117.955C120.123 32.2796 122.409 31.1946 122.409 29.1209C122.409 28.3069 122.051 27.4346 121.177 27.1051V27.086C122.37 26.5432 122.867 25.5158 122.867 24.6053C122.867 23.1325 121.634 22.2991 119.765 22.2991ZM118.214 26.2332C118.89 26.2332 119.446 25.7098 119.446 25.1088C119.446 24.6828 119.168 24.3728 118.552 24.3728H117.299L116.921 26.2332H118.214ZM117.637 30.1863C118.293 30.1863 118.969 29.6828 118.969 28.9659C118.969 28.5009 118.671 28.1905 118.055 28.1905H116.523L116.126 30.1863H117.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_2",
    d: "M102.525 28.2294C103.241 29.0628 104.335 29.5472 105.348 29.5472C106.502 29.5472 107.635 28.9268 107.635 27.7449C107.635 27.0665 107.218 26.6985 106.184 26.6985H104.135L104.672 23.9849H106.403C107.377 23.9849 108.371 23.3069 108.371 22.2795C108.371 21.5821 107.993 21.1361 106.979 21.1361C106.263 21.1361 105.329 21.3496 103.976 22.2795L102.744 19.8187C104.434 18.5199 106.303 18.1904 107.556 18.1904C110.022 18.1904 112.05 19.3338 112.05 21.6595C112.05 23.2294 111.036 24.5278 109.525 25.1283L109.505 25.1672C110.479 25.6131 111.195 26.6015 111.195 27.8804C111.195 30.7486 108.232 32.5124 105.368 32.5124C103.44 32.5124 101.59 31.7175 100.536 30.3997L102.525 28.2294Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_363",
    x1: 66.7091,
    y1: 31.1771,
    x2: 76.4463,
    y2: 42.8566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_363",
    x1: 66.8422,
    y1: 20.8501,
    x2: 80.062,
    y2: 30.0357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99F6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_108_363",
    x1: 61.5476,
    y1: 14.3071,
    x2: 61.5476,
    y2: 36.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZvukColorDarkPadding);
export default __webpack_public_path__ + "static/media/zvuk-color-dark-padding.73825db8aa0c3c85fd9b17997ef09867.svg";
export { ForwardRef as ReactComponent };